import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { resolveTheme } from '../themes/clients'
import { getClientType } from '../services/clientConfig'

export const useMount = mount => useEffect(mount, [])

export const useUnmount = unmount => useEffect(() => unmount, [])

export const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return
      }
      handler(event)
    }
    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)
    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler])
}

export const useTheme = () => {
  const { i18n } = useTranslation()
  const clientType = useMemo(() => getClientType(), [])

  return useMemo(() => ({
    ...resolveTheme(clientType, i18n.language),
    language: i18n.language
  }), [clientType, i18n.language])
}

export const useModuleConfig = moduleName => {
  const theme = useTheme()
  return theme?.modules[moduleName]
}
